/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable no-console */
import { onReady, getCurrentRegion, getCookie, createCookie, convertHMS, loadScript } from "/Assets/js/utilities.js";
import vidyardEmbed from "@vidyard/embed-code";

function onYouTubeIframeAPIReady() {
    initializeGalleries();
}
window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

onReady(() => {
    if ($(".youtubeSlide").length > 0 && getCurrentRegion() !== "China") {
        loadScript("https://www.youtube.com/iframe_api");
    } else {
        initializeGalleries();
    }
});

function initializeGalleries() {
    var options;
    if ($("[data-single-video]").length > 0) {
        $("[data-single-video]").each(function (idx, element) {
            let singleVideo = new MediaGallery(element, options);
            singleVideo.init();
        });
    }

    if ($(".media-gallery-cntnr").length > 0) {
        options = { type: "productgallery" };
        $(".media-gallery-cntnr").each(function (idx, element) {
            let mediaGallery = new MediaGallery(element, options);
            mediaGallery.init();
        });
    }

    if ($(".galleryContainer").length > 0) {
        if ($(".main-content.careers").length > 0) {
            options = {
                item: 6,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            item: 4,
                            slideMove: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            item: 2,
                            slideMove: 1
                        }
                    }
                ]
            };
            $(".galleryContainer").each(function (idx, element) {
                let careersGallery = new MediaGallery(element, options);
                careersGallery.init();
            });

        } else {
            $(".galleryContainer").each(function (idx, element) {
                let gallery = new MediaGallery(element);
                gallery.init();
            });
        }
    }
}

export default class MediaGallery {
    constructor(element, options) {
        this.$elem = $(element);
        this.vidyardPlayerStopped = true;
        this.vyApi;

        const defaults = {
            type: "vertical",
            item: 4,
            loop: false,
            slideMargin: 5,
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        item: 3,
                        slideMove: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        item: 2,
                        slideMove: 1
                    }
                }
            ]
        };
        this.options = $.extend({}, defaults, options);
    }

    init() {
        var self = this;
        self.vyApi = vidyardEmbed;

        if (typeof self.$elem.data("single-video") !== "undefined") {
            self.showSingleVideo();
        } else {
            self.$slider = self.$elem.find(".gallerySlider");
            self.$mediaPanel = self.$elem.find(".mediaPanel");
            self.$mediaDisplayPanel = self.$elem.find("div.mediaDisplayPanel");
            self.$mediaInfoPanel = self.$elem.find("div.mediaInfoPanel");
            self.$galleryPanel = self.$elem.find(".galleryPanel");
            self.$galleryPanelCol = self.$galleryPanel.parent();
            self.isVertical = self.options.type === "vertical" ? true : false;
            self.isProductGallery = self.options.type === "productgallery" ? true : false;
            self.$videoModal = $(".product-media-gallery #videoModal");
            self.$lightboxModal = $(".product-media-gallery #lightbox");
            self.$carousel = $(".product-media-gallery #carousel");

            if (!self.$elem.hasClass("initialized")) {
                self.$elem.addClass("initialized");
                self.$elem.data("gallery", self.$elem);

                // Initialize the media display elements based upon the type of listItems
                if (self.$slider.find("li.youtubeSlide").length > 0) {
                    self.$mediaDisplayPanel.append(
                        `<div id="${self.$mediaDisplayPanel.attr("id")}_youtube" class="youtube"></div>`
                    );
                }
                if (self.$slider.find("li.sketchfabSlide").length > 0) {
                    self.$mediaDisplayPanel.append(
                        `<div id="${self.$mediaDisplayPanel.attr("id")
                        }_sketchfab" class="embed-responsive-item sketchfab-embed-wrapper"/>`
                    );
                }
                if (self.$slider.find("li.imageSlide").length > 0) {
                    self.$mediaDisplayPanel.append(
                        `<img id="${self.$mediaDisplayPanel.attr("id")
                        }_img" class="embed-responsive-item img-responsive" src="" />`
                    );
                }
            }

            if (self.isVertical) {
                var slider = self.$slider
                    .lightSlider({
                        controls: false,
                        pager: false,
                        gallery: false,
                        item: self.options.item,
                        loop: self.options.loop,
                        slideMargin: self.options.slideMargin,
                        responsive: self.options.responsive,
                        onSliderLoad: function (el) {
                            self.showSlide($("li.active", el), false);
                        }
                    })
                    .show();
                $(".slideControls .slidePrev").click(function () {
                    slider.goToPrevSlide();
                });

                $(".slideControls .slideNext").click(function () {
                    slider.goToNextSlide();
                });

                if (self.$slider.children("li").size() <= 1) {
                    self.$slider.hide();
                    self.$galleryPanelCol.hide();
                } else {
                    self.$slider.find("li").each(function (idx, element) {
                        if ($(element).hasClass("vidyardSlide")) {
                            var vidTitle, vidDuration;
                            var vidId = $(element).data("src");
                            var durationCntnr = $(element).find("[data-video-duration]");

                            self.vyApi.api
                                .getPlayerMetadata(vidId)
                                .then((metadata) => {
                                    vidDuration = metadata.length_in_seconds;
                                    vidTitle = metadata.name;
                                    self.$mediaDisplayPanel.attr("data-video-title", vidTitle);
                                    $(element).attr("data-video-title", vidTitle);
                                    $(`#vgModal-${vidId}`)
                                        .find("input.videoTitle")
                                        .val(vidTitle);

                                    if (durationCntnr.length) {
                                        $(durationCntnr).text(convertHMS(vidDuration));
                                    }
                                })
                                .catch(() => {
                                    console.error("error fetching player metadata");
                                });
                        }
                    });
                }
            } else {
                self.showSlide(self.$slider.find("li:first"), false);
            }
            self.bindEvents();
        }
    }

    bindEvents() {
        var self = this;

        self.$slider.find("li").on("click",
            function () {
                self.showSlide($(this), true);
            });

        self.$videoModal.on("hide.bs.modal",
            function () {
                self.pauseCurrentSlide();
            });

        self.$lightboxModal.on("show.bs.modal",
            function (e) {
                const trigger = $(e.relatedTarget);
                const slide = trigger.data("slide-to");
                self.startCarousel(parseInt(slide));
            });

        self.$lightboxModal.on("hide.bs.modal",
            function () {
                self.resetCarousel();
            });

        if (typeof $$epiforms !== "undefined") {
            $$epiforms(document).ready(function myfunction() {
                // TODO allow multiple video gate forms in media gallery on one page.
                $$epiforms(".EPiServerForms").on("formsSubmitted",
                    function (e) {
                        var formName = $(e.currentTarget).attr("name");
                        formName = formName ? formName : e.workingFormInfo.Name;
                        if (formName !== "video-gate") return;
                        createCookie("_hyp_vgform",
                            true,
                            365); //TODO check on number of days to save cookie
                        $(".modal").modal("hide");
                        self.renderVidyardVideo();
                    });
            });
        }
    }

    showVideoGate(listItem) {
        var show = false;
        const hasVideoGateElement = listItem.data("video-gate") === "True" ? true : false;
        const videoGateCookie = getCookie("_hyp_vgform");

        if (videoGateCookie === null && hasVideoGateElement) {
            show = true;
        }

        return show;
    }

    startCarousel(slide) {
        var self = this;
        self.$carousel.carousel(slide).carousel("cycle");
    }

    resetCarousel() {
        var self = this;
        self.$carousel.carousel("pause").carousel(0);
    }

    isMobile() {
        return ResponsiveBootstrapToolkit.is("xs");
    }

    showSingleVideo() {
        var self = this;
        const videoId = self.$elem.data("src");

        if (self.$elem.hasClass("sketchfabSlide")) {
            const videoUrl = `https://sketchfab.com/models/${videoId}/embed?preload=1`;
            self.$elem
                .append(
                    `<div class="sketchfab-embed-wrapper"><iframe width="100%" height="100%" src="${videoUrl
                    }" frameborder="0" allowvr allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true" onmousewheel=""></iframe></div>`
                );
        } else if (self.$elem.hasClass("youtubeSlide")) {
            const youtubeFrame = self.$elem
                .append(
                    `<div id="${self.$elem.attr("id")}_youtube" class="youtube"></div>`
                )
                .find("div.youtube");

            if (getCurrentRegion() !== "China") {
                new YT.Player(youtubeFrame.attr("id"),
                    {
                        width: "100%",
                        height: "100%",
                        videoId: self.$elem.data("src"),
                        playerVars: { rel: 0 },
                        events: {
                            onReady: function (event) {
                                if (youTubeQueue.content) youTubeQueue.pop();
                                if (self.$elem.data("YT.Player") == null)
                                    self.$elem.data("YT.Player", event.target);
                            }
                        }
                    });
            }
        } else if (self.$elem.hasClass("vidyardSlide")) {
            var vidTitle;
            self.vyApi.api
                .getPlayerMetadata(videoId)
                .then((metadata) => {
                    vidTitle = metadata.name;
                    self.$elem.attr("data-video-title", vidTitle);
                })
                .catch(() => {
                    console.error("error fetching player metadata");
                });

            self.$elem.append(
                `<div data-uuid="${videoId}" class="embed-responsive-item vidyard_embed"/></div>`
            );

            const img = $("<img />").attr({
                class: "img-responsive",
                src: `https://play.vidyard.com/${videoId}.jpg?play_button=1`,
                "data-v": "4",
                "data-type": "inline"
            });
            img.attr({
                "data-uuid": videoId
            });
            img.addClass("vidyard-player-embed");

            if (typeof self.$elem.data("cc") !== "undefined") {
                img.attr({
                    "data-cc": `${self.$elem.data("cc")}`
                });
            }
            const vidCntnr = $(`div[data-uuid='${videoId}']`);
            vidCntnr.append(img).show();
            self.vyApi.api.renderDOMPlayers();
        } else {
            console.error("unknown slide type");
        }
    }

    showSlide(listItem, autoPlay) {
        var self = this;

        if (listItem.length !== 1) return;

        if (listItem.hasClass("current") && !self.isMobile()) return;

        var videoId;

        // Remove current active and set new active slide
        self.pauseCurrentSlide();
        self.$elem.find(".current").removeClass("current");
        listItem.addClass("current");

        if (
            self.$mediaInfoPanel !== null &&
            self.$mediaInfoPanel !== undefined &&
            self.$mediaInfoPanel.length > 0
        )
            self.$mediaInfoPanel.html(listItem.children("div.info").clone().show());

        // Store this at the media panel level so we can test if we are already loaded
        self.$mediaPanel.data("src", listItem.data("src"));
        if (listItem.hasClass("imageSlide")) {
            self.$mediaDisplayPanel
                .removeClass("embed-responsive-16by9")
                .removeClass("embed-responsive");
        } else {
            self.$mediaDisplayPanel.addClass("embed-responsive");
            self.$mediaDisplayPanel.addClass("embed-responsive-16by9");
        }

        if (listItem.hasClass("imageSlide")) {
            self.$mediaDisplayPanel.children("iframe.youtube,div.vidyard_embed").hide();
            self.$mediaDisplayPanel.children("div.sketchfab-embed-wrapper").hide();
            self.$mediaDisplayPanel
                .children("img")
                .attr("src", listItem.data("src"))
                .show();

        } else if (listItem.hasClass("sketchfabSlide")) {
            self.$mediaDisplayPanel.children("img,div.vidyard_embed").hide();
            self.$mediaDisplayPanel.children("iframe.youtube,img").hide();
            self.$mediaDisplayPanel.children("div.sketchfab-embed-wrapper").remove();

            videoId = listItem.data("src");
            var videoURL = `https://sketchfab.com/models/${videoId}/embed?preload=1`;

            self.$mediaDisplayPanel
                .append(
                    `<div class="sketchfab-embed-wrapper"><iframe width="100%" height="100%" src="${videoURL
                    }" frameborder="0" allowvr allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true" onmousewheel=""></iframe></div>`
                )
                .show();

        } else if (listItem.hasClass("youtubeSlide")) {
            self.$mediaDisplayPanel.children("img,div.vidyard_embed").hide();
            self.$mediaDisplayPanel.children("div.sketchfab-embed-wrapper").hide();
            self.$mediaDisplayPanel.children("iframe.youtube").remove();

            var youtubeFrame = self.$mediaDisplayPanel
                .append(
                    `<div id="${self.$mediaDisplayPanel.attr("id")}_youtube" class="youtube"></div>`
                )
                .find("div.youtube");

            if (getCurrentRegion() !== "China") {
                new YT.Player(youtubeFrame.attr("id"),
                    {
                        width: "100%",
                        height: "100%",
                        videoId: listItem.data("src"),
                        playerVars: { rel: 0 },
                        events: {
                            onReady: function (event) {
                                if (youTubeQueue.content) youTubeQueue.pop();
                                if (self.$mediaDisplayPanel.data("YT.Player") == null)
                                    self.$mediaDisplayPanel.data("YT.Player", event.target);
                                if (!self.isMobile() && autoPlay) self.playCurrentSlide();
                            }
                        }
                    });
            }
        } else if (listItem.hasClass("vidyardSlide")) {
            self.$mediaDisplayPanel.children("iframe.youtube,img").hide();
            self.$mediaDisplayPanel.children("div.sketchfab-embed-wrapper").hide();
            self.$mediaDisplayPanel.children("div.vidyard_embed").hide();

            var vidId = $(listItem).data("src");
            var vidCntnr = $(`div[data-uuid='${vidId}']`);
            var hasVideoGate = self.showVideoGate(listItem);

            if (vidCntnr.length === 1) {
                vidCntnr.show();
            } else {
                self.$mediaDisplayPanel.append(
                    `<div data-uuid="${vidId}" class="embed-responsive-item vidyard_embed"/></div>`
                );

                var img = $("<img />").attr({
                    class: "img-responsive",
                    src: `https://play.vidyard.com/${vidId}.jpg?play_button=1`,
                    "data-v": "4",
                    "data-type": "inline"
                });

                if (hasVideoGate) {
                    img.attr({
                        "data-video-uuid": vidId
                    });
                    img.attr({
                        "data-toggle": "modal"
                    });
                    img.attr({
                        "data-target": `#vgModal-${vidId}`
                    });
                    img.attr({
                        role: "button"
                    });
                } else {
                    img.attr({
                        "data-uuid": vidId
                    });
                    img.addClass("vidyard-player-embed");
                }

                if (typeof listItem.data("cc") !== "undefined") {
                    img.attr({
                        "data-cc": `${listItem.data("cc")}`
                    });
                }

                vidCntnr = $(`div[data-uuid='${vidId}']`);
                vidCntnr.append(img).show();
            }

            if (!hasVideoGate) {
                self.vyApi.api.renderDOMPlayers();
            }

            if (autoPlay && hasVideoGate) {
                $(`#vgModal-${videoId}`).modal("show");
            } else {
                if (!self.isMobile() && autoPlay) {
                    self.playCurrentSlide();
                }
            }
        } else {
            console.error("unknown slide type");
        }
    }

    renderVidyardVideo() {
        var self = this;

        const $img = self.$elem.find("[data-video-uuid]");
        const uuid = $img.data("video-uuid");
        $img.attr("data-uuid", uuid);
        $img.addClass("vidyard-player-embed");

        self.vyApi.api.renderDOMPlayers();
        self.playCurrentSlide();
    }

    pauseCurrentSlide() {
        var self = this;

        var player;
        const currentSlide = self.$elem.find(".current");
        if (currentSlide.length !== 1) return;

        if (currentSlide.hasClass("youtubeSlide")) {
            player = YT.get(self.$mediaDisplayPanel.attr("id") + "_youtube");
            if (player !== null) {
                if (typeof player.playVideo === "function") {
                    player.pauseVideo();
                }
            }
        } else if (currentSlide.hasClass("vidyardSlide")) {
            self.stopVidyardPlayers();
        }
    }

    playCurrentSlide() {
        var self = this;

        var player;
        const currentSlide = self.$elem.find(".current");
        if (currentSlide.length !== 1) return;

        if (currentSlide.hasClass("youtubeSlide")) {
            player = YT.get(self.$mediaDisplayPanel.attr("id") + "_youtube");
            if (player !== null) {
                self.isYouTubePlayerReady(player)
                    ? player.playVideo()
                    : youTubeQueue.push(function () {
                        player.playVideo();
                    });
            }
        } else if (currentSlide.hasClass("vidyardSlide")) {
            const videoId = currentSlide.data("src");
            const players = self.vyApi.api.getPlayersByUUID(videoId);
            player = players[0];
            self.startVidyardPlayer(player);
        }
    }

    startVidyardPlayer(player) {
        var self = this;

        if (self.vidyardPlayerStopped) {
            self.vidyardPlayerStopped = false;

            player.on("ready",
                function () {
                    setTimeout(function () {
                        // Vidyard automatically starts all players, so have to stop others.
                        self.vyApi.players.forEach(function (p) {
                            if (p.uuid === player.uuid) {
                                p.play();
                            } else {
                                p.pause();
                            }
                        });
                    },
                        1000);
                });
        }
    }

    stopVidyardPlayers() {
        var self = this;

        self.vyApi.players.forEach(function (player) {
            player.pause();
            player.off("ready");
            self.vidyardPlayerStopped = true;
        });
    }

    isYouTubePlayerReady(player) {
        return player && typeof player.playVideo === "function";
    }
}

var youTubeQueue = {
    content: null,
    push: function (fn) {
        this.content = fn;
    },
    pop: function () {
        this.content.call();
        this.content = null;
    }
};
